export default function getBadgingUsageMetrics(reportData) {
  let badgeCount = 0;
  let activityCount = 0;
  let sessionTime = 0;

  for (const row of reportData) {
    badgeCount += row.badgeCount;
    activityCount += row.activityCount;
    sessionTime += row.sessionTime;
  }
  
  return { badgeCount, activityCount, sessionTime }
}